'use client';

import { useQuery } from '@tanstack/react-query';

import {
  getUserPermissionsService,
  getUserService,
} from '@/services/firebaseServices/AuthServices';
import type { ServiceConfig } from '@/services/httpServices/types';

import { userQueryKey, userRoleQueryKey } from './userRoleQueryKeys';

/**
 * Hook for fetching user role/permissions from API
 * Requires httpRequestConfig with space
 */
export function useUserRoleQuery(config: ServiceConfig) {
  const hasSpace = config.httpRequestConfig.space !== undefined
    && config.httpRequestConfig.space !== null
    && config.httpRequestConfig.space !== '';

  return useQuery({
    queryKey: userRoleQueryKey(config),
    queryFn: async () => getUserPermissionsService(config),
    enabled: hasSpace,
  });
}

/**
 * Hook for fetching current Firebase user
 * Does NOT require space - fetches authenticated user from Firebase
 * Can be used outside of SpaceProvider context
 */
export function useUserQuery() {
  return useQuery({
    queryKey: userQueryKey(),
    queryFn: async () => getUserService(),
  });
}
